__turbopack_context__.v({
  "caption": "style-module-scss-module__Xfj-fq__caption",
  "card": "style-module-scss-module__Xfj-fq__card",
  "image": "style-module-scss-module__Xfj-fq__image",
});
